export enum SEInputEventNameEnum {
    AUTOCOMPLETE = "autocompleteValue",
    REGIONS = "regionsValue",
    STATIONS = "stationsValue",
    PARENT_STATIONS = "parentStationsValue",
    PARTICIPANTS = "participantsValue",
}